import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import LinhVuc from './linh-vuc';
import LinhVucDetail from './linh-vuc-detail';
import LinhVucUpdate from './linh-vuc-update';
import LinhVucDeleteDialog from './linh-vuc-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={LinhVucUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={LinhVucUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={LinhVucDetail} />
      <ErrorBoundaryRoute path={match.url} component={LinhVuc} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={LinhVucDeleteDialog} />
  </>
);

export default Routes;
